///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PasswordResetFinishService } from './password-reset-finish.service';
import { finalize } from 'rxjs';
import { createPasswordFieldsPair } from '../../../shared/password-field.generator';
import { SuiTypeString } from '@siklu/sui-lib/infrastructure';

@Component({
    selector: 'winde-password-reset-finish',
    templateUrl: './password-reset-finish.component.html',
    styleUrls: ['../../password/password.component.scss'],
    standalone: false
})
export class PasswordResetFinishComponent {
    public passwordChangeAttempted = false;
    public requestResult: { isSuccess: boolean; message: string } = { isSuccess: false, message: '' };
    public key: string = this.route.snapshot.queryParamMap.get('key');

    public newPassword: SuiTypeString;
    public confirmationPassword: SuiTypeString;

    constructor(
        private readonly passwordResetFinishService: PasswordResetFinishService,
        private readonly route: ActivatedRoute
    ) {
        if (this.key) {
            [this.newPassword, this.confirmationPassword] = createPasswordFieldsPair();
        }
    }

    public finishReset(): void {
        if (!this.newPassword.validateAndShowError() || !this.confirmationPassword.validateAndShowError()) {
            return;
        }

        this.passwordResetFinishService
            .save({ key: this.key, newPassword: this.newPassword.value })
            .pipe(finalize(() => (this.passwordChangeAttempted = true)))
            .subscribe({
                next: () => {
                    this.requestResult.isSuccess = true;
                    this.requestResult.message = 'reset.finish.messages.success';
                },
                error: () => {
                    this.requestResult.isSuccess = false;
                    this.requestResult.message = 'reset.finish.messages.error';
                }
            });
    }
}
